// 
// ─── IMPORT DES ELEMENTS NECESSAIRES ───────────────────────────────────────
//
import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import Api from '../contexts/Api';
import Formfields from "../components/Formfields";
import { prepareFormData, getValue } from '../contexts/Utils';
import Button from '@mui/material/Button';
import { useNotification } from '../components/UseNotification';
import ArrowBack from '../components/ArrowBack';

// 
// ─── DECLARATION DU COMPOSANT ───────────────────────────────────────
//
const InventoryManage = (props) => {
  const { notification } = useNotification();
  let navigate = useNavigate();
  let defaults = props.defaults || {}

  const [errors, setErrors] = useState({});

  // 
  // ─── HANDLE FORM SUBMIT ───────────────────────────────────────
  //
  const handleChange = async () => {
    let data = prepareFormData({ formId: 'myForm' });

    if (data.errors) {
      setErrors(data.errors)
    } else {

      if (props.update) {
        data.inventory_id = defaults.inventory_id
      }

      const params = {
        data,
        endpoint: '/inventory',
        method: props.update ? 'PUT' : 'POST'
      }

      const createInventory = await Api(params)
      notification({ variant: createInventory.success ? 'success' : 'error', message: createInventory.message });

      if (createInventory.success) {
        return navigate("/outils/inventaire");
      }
    }
  }

  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    container: {
      display: 'flex',
      gap: 20
    },
    card: {
      flex: 1,
      background: 'var(--block-color)',
      boxShadow: '0px 4px 44px 3px rgba(0, 0, 0, 0.08)',
      padding: 20,
      borderRadius: 20,
      '&>div:not(:first-child)': {
        marginTop: 20
      }
    },
    submit: {
      margin: '20px auto 10px !important'
    }
  })
  const classes = useStyle();

  // 
  // ─── FORM FIELDS ───────────────────────────────────────
  //
  const formFields = [
    {
      fields: [
        { component: "text", name: "name", label: "Nom de l'élément" },
        { component: "text", multiline: true, rows: 4, name: "description", label: "Description" },
        {
          type: "select", component: "select", name: "category", label: "Type d'article", dataLabel: 'name', dataValue: 'id', default: defaults.category || '', data: Object.values(window._DATA.types['inventory_category']).map((type) => {
            return { id: type.value, name: type.label }
          }),
        },
        { component: "text", name: "brand", label: "Marque" },
        { component: "text", name: "vendor", label: "Vendeur" },
        { type: 'number', component: "texte", name: "quantity", label: "Quantité" },
        { component: "text", name: "price", label: "Prix" },
      ]
    }
  ]

  // 
  // ─── RENDU DU COMPOSANT ───────────────────────────────────────
  //
  return <div>
    <ArrowBack link='/outils/inventaire' />
    <form onSubmit={handleChange} className={classes.form} name="myForm">
      <div className={classes.container}>
        {formFields.map((element, index) => {
          return <div key={index} className={classes.card}>
            {element.fields.map((el) => {
              if (el.hasOwnProperty('cond') && !el.cond) return true
              if (defaults[el.name] && !el.default) el.default = defaults[el.name]

              // 
              // ─── DISPLAY FIELDS ───────────────────────────────────────
              //
              return <Formfields key={el.name} field={{ ...el, error: getValue(errors, [el.name, 'message']) }} slug={props.slug} />
            })}
          </div>
        })}
      </div>
      <Button variant="contained" className={classes.submit} onClick={handleChange}>Enregistrer</Button>
    </form>
  </div >
};

export default InventoryManage;